import styled from 'styled-components';

export const CarouselContainer = styled.div`
  font-family: 'Pretendard';
  position: relative;
  width: 90%;
  margin: 0px auto 0;

  .slick-slider {
    position: static;
  }

  .slick-list {
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .slick-track {
    display: flex;
  }

  .slick-slide > div {
    position: relative;
  }

  .slick-dots {
    position: absolute !important;
    bottom: 15px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: auto !important;
    display: flex !important;
    justify-content: center;
    gap: 8px;
    z-index: 100;
    margin: 0;
    padding: 0;
  }

  .slick-dots li {
    width: 8px;
    height: 8px;
    margin: 0;
    list-style: none;
  }

  .slick-dots li button {
    width: 8px;
    height: 8px;
    padding: 0;
    font-size: 0;
    line-height: 0;
    display: block;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:before {
    content: '•';
    width: 8px;
    height: 8px;
    font-size: 12px;
    line-height: 8px;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
  }

  .slick-dots li.slick-active button:before {
    color: white;
  }
`;

export const ProfileBox = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #1fbc70;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .img1 {
    width: 70px;
    height: 70px;
    border-radius: 10px;
    object-fit: cover;
  }
`;

export const img = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const Title = styled.div`
  color: #ffffff;
  display: flex;
  align-items: baseline;
  gap: 2px;
`;

export const Name = styled.span`
  font-weight: 700;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: -0.5px;
`;

export const Sub = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 1.2;
  letter-spacing: -0.5px;
`;

export const ClassInfo = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.5px;
  color: #ffffff;
  opacity: 0.9;
  margin-top: 5px;
`;

export const Reservation = styled.div`
  display: flex;
  background-color: #ffffff66;
  border-radius: 20px;
  margin-top: 5px;
  margin-bottom: 20px;
  overflow: hidden;
  height: 60px;
`;

export const Left = styled.div`
  font-size: 15px;
  flex: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5c5d61;
  font-weight: 500;
`;

export const Right = styled.div`
  font-size: 15px;
  flex: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5c5d61;
  font-weight: 500;
`;

export const VerticalBorder = styled.div`
  width: 1px;
  background-color: #ffffff99;
  align-self: stretch;
`;

export const BoxLine = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  background-color: #f1fff3;
  padding: 20px;
  gap: 10px;
`;

export const Phrase = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.5px;
  text-align: center;
  color: #1fbc70;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
`;

export const Left1 = styled.div`
  font-size: 15px;
  flex: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
`;

export const Right1 = styled.div`
  font-size: 15px;
  flex: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
`;

export const Reservation1 = styled.div`
  display: flex;
  background-color: #1fbc70;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 5px;
  margin-bottom: 20px;
  height: 60px;
`;

export const InUseBox = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #C8F5DC;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InUseHeader = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

export const FacilityImage = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 10px;
  object-fit: cover;
`;

export const InUseInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  align-items: flex-start;
`;

export const InUseNameRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const InUseFacilityName = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #333333;
  line-height: 1.2;
`;

export const InUseStatus = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #666666;
  line-height: 1.2;
`;

export const InUseTime = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 1.2;
`;

export const InUseButtons = styled.div`
  display: flex;
  background-color: #1fbc70;
  border-radius: 20px;
  margin-top: 5px;
  margin-bottom: 20px;
  overflow: hidden;
  height: 60px;
`;

export const InUseButtonLeft = styled.div`
  font-size: 15px;
  flex: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
`;

export const InUseButtonRight = styled.div`
  font-size: 15px;
  flex: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
`;

export const InUseButtonDivider = styled.div`
  width: 1px;
  background-color: #ffffff99;
  align-self: stretch;
`;
